import React from "react";
import ExploreSection from "../layout/ExploreSection";
import ArticleCarousel from "../layout/ArticleCarousal";
import ContactForm from "../common/ContactForm";
import Hero from "../layout/Hero";

const Home = () => {
  return (
    <div className="min-h-screen  bg-white text-black">
      <Hero />
      <ExploreSection />
      <ArticleCarousel />
      <ContactForm />
    </div>
  );
};

export default Home;
